import getConfig from 'next/config'

// This should match publicRuntimeConfig from .next.config.js
interface Config {
  apiEnv: 'production' | 'staging' | 'development'
  embedServiceUri: string
  googleMapsApiKey: string
  graphqlUri: string
  knockApiPublicKey: string
  knockFeedId: string
  multipleImagesEnabled: boolean
  nextBuildId: string
  segmentId: string
  skimlinksId: string
  stripePublishableKey: string
}

const { publicRuntimeConfig } = getConfig()
export const config: Config = publicRuntimeConfig
